import React from 'react'
import '../styles/footer.css'
const Footer = () => {
  return (
    <section>
      <h4 className='footer'>
        Made with ❤️ from Anish
      </h4>
    </section>
  )
}

export default Footer